import { createVNode as a, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DoctorFemaleTwotoneStandard.js";
import d from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return a(d, n(e, {
    icon: m
  }), null);
};
o.displayName = "DoctorFemaleTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
